import { useState } from 'react'

import { useTranslation } from 'react-i18next'

import { observer } from 'mobx-react-lite'

// import { getPurchasePassenger } from 'pages/avia/purchase-form/pages/confirm/lib/preparePurchaseForm'
import { mplusStore } from 'entities/mplus/module/mplus-store'
import { MplusPopup } from 'entities/mplus/ui/mplus-popup'
import { mplus_deeplink } from 'entities/mplus/ui/take-in-mplus/constants'

// import listTicketsStore from 'entities/ticket/models/list-tickets/list-tickets-store'
// import userStore from 'entities/user/module/user-store'
// import { BuyTicketApi } from 'shared/api/BuyTicket'
// import { BuyTicket } from 'shared/api/BuyTicketModel'
import ErrorImage from 'shared/images/error.png'
import { openDeepLink } from 'shared/lib/deep-link-open'
import { getErrorMessage } from 'shared/lib/errorText'
import { useDialogBottomSheet } from 'shared/ui/dialog-bottom-sheet/lib'
import { MPlusConnect } from 'shared/ui/mplus-connect'
import { PopupContent } from 'shared/ui/poup-content'

const MPlus = observer(() => {
  const [isLoader, setLoader] = useState(false)

  const { t } = useTranslation()

  const { closeDialog, openDialog } = useDialogBottomSheet()

  // const PRODUCTION = 'production'

  const aviaInstallment = mplusStore.getAviaInstallmentData()

  const totalPrice = Number(aviaInstallment?.price)
  const quantity = aviaInstallment?.quantity

  const handleAviaPurchase = async () => {
    // setLoader(true)
    const passengerData = mplusStore.getPassengersForm()

    try {
      if (passengerData) {
        // if (import.meta.env.MODE === PRODUCTION) {
        //   window.ym(97487684, 'reachGoal', 'buyTicket')
        // }

        // const passengersPurchasePrepared = getPurchasePassenger(passengerData)

        // const selectedTicket = listTicketsStore.selectedTicket

        // const preparedData: BuyTicket = {
        //   price: String(
        //     listTicketsStore.currentTariffFamily?.price?.KGS ||
        //       selectedTicket?.price?.KGS,
        //   ),
        //   tid: String(
        //     listTicketsStore.currentTariffFamily?.tid || selectedTicket?.tid,
        //   ),
        //   phone_number: userStore?.account?.phone_number || '',
        //   email: passengerData.email,
        //   passengers: passengersPurchasePrepared,
        // }

        // await BuyTicketApi.buyTicket(preparedData)

        // setLoader(false)

        openDialog({
          child: (
            <MplusPopup
              title={t('mplus.your_ticket_booked')}
              description={t('mplus.redirect_ticket')}
              onClick={() => openDeepLink(mplus_deeplink)}
            />
          ),
          isDialog: false,
          isClickable: false,
        })
      } else {
        openDeepLink(mplus_deeplink)
      }
    } catch (err) {
      const errorText = getErrorMessage(err)

      onShowError(errorText)

      setLoader(false)
    }
  }

  const onShowError = (errorMessage?: string) => {
    openDialog({
      child: (
        <PopupContent
          image={ErrorImage}
          title={t('error')}
          description={errorMessage || t('please_tey_again')}
          button={t('try_again')}
          onClick={closeDialog}
        />
      ),
      isDialog: false,
    })
  }

  return (
    <MPlusConnect
      loaderType="avia"
      totalPrice={totalPrice}
      quantity={quantity!}
      isLoader={isLoader}
      onSubmit={handleAviaPurchase}
    />
  )
})

export default MPlus
